import jQuery from "jquery";

export default class FormJar {
  constructor() {
    const FormJarContainer = jQuery(".formjar");
    const FormContainer = jQuery(".fj-container");
    const FormTab = jQuery(".fj-tab");
    const Form = jQuery("#form_enquete");
    if (FormJar) {
      FormJarContainer.toggleClass("ready");

      if (
        document.body.offsetWidth < 900 ||
        jQuery.cookie("formEnqueteOpened") === "0"
      ) {
        FormJarContainer.toggleClass("collapsed");
        Form.toggleClass("hidden");
        FormContainer.toggleClass("hidden");
      }

      FormTab.on("click", function (e) {
        e.preventDefault();

        if (FormJarContainer.hasClass("collapsed")) {
          jQuery.cookie("formEnqueteOpened", "1", { expires: 180, path: "/" });
        } else {
          jQuery.cookie("formEnqueteOpened", "0", { expires: 180, path: "/" });
        }

        FormJarContainer.toggleClass("collapsed");
        Form.toggleClass("hidden");
        FormContainer.toggleClass("hidden");

        return false;
      });
    }
    return;
  }
}
